import { QueryClient } from '@tanstack/react-query';

/**
 * Global QueryClient instance for React Query.
 *
 * Configuration:
 * - staleTime: 5 minutes - Data is considered fresh for this duration
 * - gcTime: 30 minutes - Unused data stays in cache for this duration
 * - refetchOnWindowFocus: Refetch when user returns to the tab
 * - refetchInterval: Auto-refresh every 5 minutes
 * - refetchIntervalInBackground: Continue auto-refresh even when tab is inactive
 * - retry: 3 attempts with exponential backoff (default)
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,           // Data fresh for 5 minutes
      gcTime: 30 * 60 * 1000,             // Keep in cache for 30 minutes
      refetchOnWindowFocus: true,         // Refetch when user returns to tab
      refetchInterval: 5 * 60 * 1000,     // Auto-refresh every 5 minutes
      refetchIntervalInBackground: true,  // Continue refreshing when tab inactive
    },
  },
});
